/*
 * @Author: qiaohui 2323468356@qq.com
 * @Date: 2022-04-22 17:37:34
 * @LastEditors: qiaohui 2323468356@qq.com
 * @LastEditTime: 2022-05-09 14:21:44
 * @FilePath: /chongqing_ringtone/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Home.vue'
import InfoPage from '../views/Home/Info'
import PrivacyPage from '../views/Privacy/index'
// import Login from '../views/Login/Login'
// import PopupPlayer from '../views/Popup-player/Popup-player'
// import ChoosePhone from '../views/choosePhone'
// import FishIdle from '../views/FishIdle/FishIdle'
// import Year from '../views/Year/Year'
// /Users/qh/Desktop/work/xuancode/vedioringtone/src/views/Popup-player/Popup-player.vue

// 测试页面
// import testPage from '../views/testPage.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/testPage',
  //   component: testPage
  // },
  // {
  //   path: '/',
  //   redirect: '/'
  // },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      tabBar: true,
      keepAlive: false,
      title: '视频彩铃'
    }
  },
  {
    path:'/InfoPage',
    name:'InfoPage',
    component:InfoPage,
    meta: {
      title: '招生表单页'
    }
  },
  {
    path:'/privacyPage',
    name:'privacyPage',
    component:PrivacyPage,
    meta: {
      title: '服务规定'
    }
  },


  // {
  //   path: '/popupPlayer',
  //   name: 'PopupPlayer',
  //   component: PopupPlayer,
  //   meta: {
  //     title: '视频名称'
  //   }
  // },
 
  
  // {
  //   path: '/search',
  //   name: 'search',
  //   component: Search,
  //   meta: {
  //     title: '搜索'
  //   }
  // },
  // {
  //   path: '/searchResult',
  //   name: 'searchResult',
  //   component: SearchResult,
  //   meta: {
  //     title: '搜索结果页'
  //   }
  // },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Login
  // },
  // {
  //   path: '/fishIdle',
  //   name: 'fishIdle',
  //   component: FishIdle
  // },
  // {
  //   path: '/year',
  //   name: 'year',
  //   component: Year
  // },


]

const router = new VueRouter({
  mode: 'history',
  base: '',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



export default router